import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import Row from 'antd/lib/grid/row';
import { FormattedMessage } from 'react-intl';
import { ShowMeHowContainer, ShowMeHowImageDescription } from './styled';
import IconSvg from '../../common/IconSvg';

@inject('onboardingStore')
@observer
class ReadyToLaunch extends React.Component {
  state = {};

  render() {
    const { onboardingStore } = this.props;
    return (
      <Row>
        <ShowMeHowContainer
          onClick={() => {
            onboardingStore.saveWizardState();
            onboardingStore.setWizardStep(onboardingStore.wizardStepIndex + 1);
            onboardingStore.enableTutorial();
          }}
        >
          <IconSvg type="telescope" size="51" />
          <ShowMeHowImageDescription>
            <FormattedMessage id="onboarding.screen7.showMeHow" />
          </ShowMeHowImageDescription>
        </ShowMeHowContainer>
      </Row>
    );
  }
}

ReadyToLaunch.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  onboardingStore: PropTypes.object,
};

export default ReadyToLaunch;
